import { defineMessages } from 'react-intl';

const messages = defineMessages({
  print: {
    description: 'orderGridPrintDocument.print',
    defaultMessage: 'Print',
    id: 'ROshh1',
  },
});

export default messages;
